import type { TagRow } from '../../../types'

// Inverse of collectPairs: turn applied `key:value` pairs (e.g. seeded from the
// URL) back into editable rows. Splits on the first colon so values may contain
// colons; a pair without a colon becomes a key with an empty value.
export function buildRowsFromPairs(pairs: string[]): TagRow[] {
  return pairs.map((pair) => {
    const separatorIndex = pair.indexOf(':')
    if (separatorIndex === -1) {
      return { key: pair, value: '' }
    }
    return {
      key: pair.slice(0, separatorIndex),
      value: pair.slice(separatorIndex + 1),
    }
  })
}
